import { render, staticRenderFns } from "./AppListSidebar.vue?vue&type=template&id=1771e37c&"
import script from "./AppListSidebar.vue?vue&type=script&lang=js&"
export * from "./AppListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppListSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports